(function ($, Drupal) {
    Drupal.behaviors.form_steps = {
        attach: function (context, settings) {

            // no form steps, nothing todo
            if (!$('.form_steps')[0]) {
                return;
            }

            var valuemissing = false;
            var activequestion = false;
            var number = 0;
            $('.form_steps > div', context).one('form_steps').each(function (index) {

              // console.log(index);
              // console.log(!$(this).children('div').is(":visible"));
              // console.log($(this).hasClass('js-webform-states-hidden'));
              // console.log($(this).children('div'));

                // probably there are dynamic fields depending on other fields the step bevopr.
                // probably better to go on class js-webform-states-hidden?
                if ($(this).hasClass('js-webform-states-hidden')) {
                  return;
                }

                // check if there is a input - probably its only a markup
                if ($(this).find('input').length == 0) {
                  return;
                }

                // check if there is a text input - currently not supported - probably used as "other" for checkboxes?
                if ($(this).find('input').attr('type') == 'text') {
                  return;
                }
                $(this).addClass('visible-step');

                var parentwrap = $(this);
                var question = $(this);
                if ($(question).hasClass('js-webform-radios-other')) {
                  question = $(this).children('.radios--wrapper');
                  $(question).find('legend span.visually-hidden').removeClass('visually-hidden');
                }
                var input = $(this).find('input');
                var hasvalue = false;
                if ($(this).find('input:checked').length > 0) {
                    // for context use
                    hasvalue = true;
                } else {
                    // for global use - submit button
                    valuemissing = true;
                }

                // check for first question without value - on reload dont have to be the first
                var firstactive = false;
                if (!hasvalue && !activequestion) {
                    activequestion = true;
                    firstactive = true;
                }

                // hide every question except the first and questions with values - probably going back or reload
                if (index > 0 && !hasvalue && !firstactive) {
                    question.children().hide();
                }

                // add numbers
                number = number + 1;
                var activeclass = 'inactive';
                // if already have a value do nothing
                if (hasvalue) {
                    activeclass = '';
                }
                if (firstactive) {
                    activeclass = 'active';
                }
                question.prepend('<div class="number number-' + number + ' ' + activeclass + '"><span>' + number + '</span></div>');

                console.log('parentwrap');
                console.log(parentwrap);

                // add next logic
                input.change(function () {
                    // only do something if the current one is the active one.
                    // if we edit an old one we have nothing to do
                    if (!$(question).children('.number').hasClass('active')) {
                        return;
                    }


                    $(question).children('.number').removeClass('active');

                    // TBD - not usefull on checkboxes - multiple choice
                    // $(question).children('.js-webform-radios').hide();
                    var next = $(parentwrap).nextAll('.visible-step').first();
                  console.log('parentwrap');
                  console.log(parentwrap);

                    console.log('next');
                    console.log(next);
                    // if there is no next question - active the next button
                    if (next.length == 0) {
                        // $('.webform-button--next').removeClass('disabled');
                    } else {
                        // active next question
                        next.children('.number').removeClass('inactive').addClass('active');
                        next.children().slideDown();
                        $('html,body').animate({scrollTop: next.offset().top}, 500);
                    }
                });
            });

            // if (valuemissing) {
            //     // disable next button
            //     $('.webform-button--next').addClass('disabled');
            // }
        }
    };

})(jQuery, Drupal);
